import { useEffect, useState } from "react";
import { QueryClient, QueryClientProvider, useQuery } from "@tanstack/react-query";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";

import { api, docToken } from "./api.ts";
import { khoa } from "./lib/khoa.ts";
import { Khung } from "./thanh-phan/Khung.tsx";
import { NhaToast } from "./thanh-phan/toast.tsx";
import { DangNhap } from "./trang/DangNhap.tsx";
import { TongQuan } from "./trang/TongQuan.tsx";
import { HangCho } from "./trang/HangCho.tsx";
import { ChiTietBai } from "./trang/ChiTietBai.tsx";
import { SoSanhModel } from "./trang/SoSanhModel.tsx";
import { BaiHoc } from "./trang/BaiHoc.tsx";
import { ChiPhi } from "./trang/ChiPhi.tsx";
import { CaiDat } from "./trang/CaiDat.tsx";
import { LichDang } from "./trang/LichDang.tsx";
import { CauTrucPrompt } from "./trang/CauTrucPrompt.tsx";
import { ChanDung } from "./trang/ChanDung.tsx";
import { Nguon } from "./trang/Nguon.tsx";
import { SanPham } from "./trang/SanPham.tsx";
import { KetNoi } from "./trang/KetNoi.tsx";

const qc = new QueryClient({
  defaultOptions: {
    queries: {
      // Một người dùng, một máy — không cần tải lại mỗi lần đổi cửa sổ.
      refetchOnWindowFocus: false,
      // 401 thì thử lại vô ích: token đã bị xoá, lần sau cũng 401.
      retry: (soLan, loi) => {
        const ma = (loi as { ma?: number }).ma;
        if (ma === 401 || ma === 400) return false;
        return soLan < 2;
      },
      staleTime: 10_000,
    },
  },
});

// `ChuaDung` đã xoá ở đợt 16: **không còn mục nào chưa dựng**. Giữ lại một component không ai
// render là giữ một câu trả lời cho câu hỏi không còn ai hỏi.

function BenTrong() {
  const { data } = useQuery({ queryKey: khoa.toi, queryFn: api.toi });
  const { data: suc } = useQuery({ queryKey: khoa.health, queryFn: api.health });

  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Khung ten={data?.ten ?? "…"} cheDo={suc?.cheDoDang ?? null} />}>
          <Route path="/" element={<TongQuan />} />
          <Route path="/hang-cho" element={<HangCho />} />
          <Route path="/bai/:id" element={<ChiTietBai />} />
          <Route path="/so-sanh-model" element={<SoSanhModel />} />
          <Route path="/bai-hoc" element={<BaiHoc />} />
          <Route path="/chi-phi" element={<ChiPhi />} />
          <Route path="/cai-dat" element={<CaiDat />} />
          <Route path="/lich" element={<LichDang />} />
          <Route path="/prompt" element={<CauTrucPrompt />} />
          <Route path="/chan-dung" element={<ChanDung />} />
          <Route path="/nguon" element={<Nguon />} />
          <Route path="/san-pham" element={<SanPham />} />
          <Route path="/ket-noi" element={<KetNoi />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export function App() {
  // Ba trạng thái, không phải hai: **chưa biết** · đã đăng nhập · chưa đăng nhập.
  // Gộp "chưa biết" vào "chưa đăng nhập" là màn login nháy lên một nhịp mỗi lần tải trang.
  const [phien, datPhien] = useState<"chua-biet" | "co" | "khong">("chua-biet");

  useEffect(() => {
    if (docToken() === null) {
      datPhien("khong");
      return;
    }
    api
      .toi()
      .then(() => datPhien("co"))
      .catch(() => datPhien("khong"));
  }, []);

  if (phien === "chua-biet") {
    return (
      <div className="flex min-h-screen items-center justify-center bg-muc-50 text-sm text-muc-400">
        Đang mở…
      </div>
    );
  }

  if (phien === "khong") return <DangNhap khiXong={() => location.reload()} />;

  return (
    <QueryClientProvider client={qc}>
      {/* Toast bọc NGOÀI router: một hành động ở màn này có thể điều hướng sang màn khác, và
          phản hồi của nó phải sống sót qua lượt điều hướng đó. */}
      <NhaToast>
        <BenTrong />
      </NhaToast>
    </QueryClientProvider>
  );
}
